function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, DatePicker, Space, InputNumber, Radio, Checkbox, Divider, Alert } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CheckboxGroup = Checkbox.Group;
var MedForm = function MedForm(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormProcessing = _useState4[0],
    setIsFormProcessing = _useState4[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append('bday', values.bday);
    formData.append('job', values.job);
    formData.append('licenseCategory', values.licenseCategory);
    formData.append('licenseType', values.licenseType);
    formData.append('isLastFiveYearHospitalized', values.isLastFiveYearHospitalized);
    formData.append('reasonFiveYearHospitalized', values.reasonFiveYearHospitalized);
    formData.append('isUnderMedication', values.isUnderMedication);
    formData.append('medicationList', values.medicationList);
    formData.append('hasDrivingIssue', values.hasDrivingIssue);
    formData.append('doWearGlasses', values.doWearGlasses);
    formData.append('alcoholFrequency', values.alcoholFrequency);
    formData.append('alcoholQuantityPerDay', values.alcoholQuantityPerDay);
    formData.append('doDrugs', values.doDrugs);
    formData.append('doneAddictionTreatment', values.doneAddictionTreatment);
    formData.append('hasHeartProblem', values.hasHeartProblem);
    formData.append('hasPacemaker', values.hasPacemaker);
    formData.append('hasViewProblem', values.hasViewProblem);
    formData.append('hasDizziness', values.hasDizziness);
    formData.append('hasMemoryProblem', values.hasMemoryProblem);
    formData.append('hasSleepTrouble', values.hasSleepTrouble);
    formData.append('didSuddenlySleep', values.didSuddenlySleep);
    formData.append('hasRespiratoryAssist', values.hasRespiratoryAssist);
    formData.append('hasLostConsciousness', values.hasLostConsciousness);
    formData.append('hasAvc', values.hasAvc);
    formData.append('hasAvcConsequences', values.hasAvcConsequences);
    formData.append('hasTrauma', values.hasTrauma);
    formData.append('hasTraumaConsequences', values.hasTraumaConsequences);
    formData.append('hasDepression', values.hasDepression);
    formData.append('hasEpilepsy', values.hasEpilepsy);
    formData.append('epilepsyDate', values.epilepsyDate);
    formData.append('doDiabete', values.doDiabete);
    formData.append('hasLackOfSugarIssues', values.hasLackOfSugarIssues);
    formData.append('hasOtherProblem', values.hasOtherProblem);
    formData.append('otherProblemList', values.otherProblemList);
    formData.append('aid', Common.currentUser.id);
    formData.append('pulse', values.pulse);
    formData.append('poids', values.poids);
    formData.append('systole', values.systole);
    formData.append('diastole', values.diastole);
    formData.append('cid', candidat.id);
    axios.post(Common.baseApiUrl + 'processmedecine', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (candidat.medecineresult_id != null) {
      form.setFieldsValue({
        bday: moment(candidat.medecine_questions.bday),
        job: candidat.medecine_questions.job,
        licenseCategory: candidat.medecine_questions.licenseCategory,
        hasTrauma: candidat.medecine_questions.hasTrauma,
        hasTraumaConsequences: candidat.medecine_questions.hasTraumaConsequences,
        licenseType: candidat.medecine_questions.licenseType,
        isLastFiveYearHospitalized: candidat.medecine_questions.isLastFiveYearHospitalized,
        reasonFiveYearHospitalized: candidat.medecine_questions.reasonFiveYearHospitalized,
        isUnderMedication: candidat.medecine_questions.isUnderMedication,
        medicationList: candidat.medecine_questions.medicationList,
        hasDrivingIssue: candidat.medecine_questions.hasDrivingIssue,
        doWearGlasses: candidat.medecine_questions.doWearGlasses,
        alcoholFrequency: candidat.medecine_questions.alcoholFrequency,
        alcoholQuantityPerDay: candidat.medecine_questions.alcoholQuantityPerDay,
        doDrugs: candidat.medecine_questions.doDrugs,
        doneAddictionTreatment: candidat.medecine_questions.doneAddictionTreatment,
        hasHeartProblem: candidat.medecine_questions.hasHeartProblem,
        hasPacemaker: candidat.medecine_questions.hasPacemaker,
        hasViewProblem: candidat.medecine_questions.hasViewProblem,
        hasDizziness: candidat.medecine_questions.hasDizziness,
        hasMemoryProblem: candidat.medecine_questions.hasMemoryProblem,
        hasSleepTrouble: candidat.medecine_questions.hasSleepTrouble,
        didSuddenlySleep: candidat.medecine_questions.didSuddenlySleep,
        hasRespiratoryAssist: candidat.medecine_questions.hasRespiratoryAssist,
        hasLostConsciousness: candidat.medecine_questions.hasLostConsciousness,
        hasAvc: candidat.medecine_questions.hasAvc,
        hasAvcConsequences: candidat.medecine_questions.hasAvcConsequences,
        hasDepression: candidat.medecine_questions.hasDepression,
        hasEpilepsy: candidat.medecine_questions.hasEpilepsy,
        epilepsyDate: moment(candidat.medecine_questions.epilepsyDate),
        doDiabete: candidat.medecine_questions.doDiabete,
        hasLackOfSugarIssues: candidat.medecine_questions.hasLackOfSugarIssues,
        hasOtherProblem: candidat.medecine_questions.hasOtherProblem,
        otherProblemList: candidat.medecine_questions.otherProblemList,
        pulse: candidat.medecine_questions.pulse,
        poids: candidat.medecine_questions.poids,
        systole: candidat.medecine_questions.systole,
        diastole: candidat.medecine_questions.diastole
      });
    }
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: errorMessage
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            form: form,
            layout: "vertical",
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx("h5", {
              children: "INFORMATIONS PERSONNELS"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "bday",
                  label: "Date de naissance",
                  children: /*#__PURE__*/_jsx(DatePicker, {})
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "job",
                  label: "Profession",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })]
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx("div", {
                  className: "pad cool-radius",
                  style: {
                    background: '#FFDE08',
                    padding: '10px'
                  },
                  children: /*#__PURE__*/_jsxs("p", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "RNC : "
                    }), candidat.rnc, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                      children: "Pr\xE9nom: "
                    }), candidat.firstname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                      children: "Nom: "
                    }), candidat.lastname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                      children: "T\xE9l\xE9phone: "
                    }), candidat.mobile, /*#__PURE__*/_jsx("br", {})]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("h5", {
              children: "INFORMATIONS PERMI\\S"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "licenseCategory",
                  label: "CATEGORIE DE PERMIS",
                  children: /*#__PURE__*/_jsx(CheckboxGroup, {
                    options: ['A', 'B', 'C', 'C1', 'D', 'E', 'F'],
                    value: ['D']
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "licenseType",
                  label: "Type de demande",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    options: [{
                      label: '1ere émission',
                      value: 1
                    }, {
                      label: 'Transformation',
                      value: 2
                    }, {
                      label: 'Renouvellement',
                      value: 3
                    }, {
                      label: 'Duplicata',
                      value: 4
                    }, {
                      label: 'Extension',
                      value: 5
                    }],
                    value: ['2']
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("h5", {
              children: "INFOS CONSULTATION"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Form.Item, {
              name: "pulse",
              label: "Pouls",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "Pulsations/minute"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "poids",
              label: "Poids",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "Kg"
              })
            }), /*#__PURE__*/_jsx("h6", {
              children: "TENSION ARTERIEL"
            }), /*#__PURE__*/_jsxs(Space, {
              wrap: true,
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "systole",
                children: /*#__PURE__*/_jsx(InputNumber, {
                  addonAfter: "Systole"
                })
              }), /*#__PURE__*/_jsx("span", {
                children: "/"
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "diastole",
                children: /*#__PURE__*/_jsx(InputNumber, {
                  addonAfter: "Diastole"
                })
              }), /*#__PURE__*/_jsx("span", {
                children: "mmHg"
              })]
            }), /*#__PURE__*/_jsx("h5", {
              children: "INFOS SANTE"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "isLastFiveYearHospitalized",
                    label: "Ai-je \xE9t\xE9 hospitalis\xE9(e) et/ou op\xE9r\xE9(e) au cours des cinq derni\xE8res ann\xE9es ?",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'Oui',
                        value: 1
                      }, {
                        label: 'Non',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "reasonFiveYearHospitalized",
                    label: "Si oui, pour quel motif ?",
                    children: /*#__PURE__*/_jsx(Input, {})
                  })]
                }), /*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "isUnderMedication",
                    label: "Est-ce que je prends des m\xE9dicaments chaque jour ?",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'Oui',
                        value: 1
                      }, {
                        label: 'Non',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "medicationList",
                    label: "Si oui, lesquels ?",
                    children: /*#__PURE__*/_jsx(Input, {})
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "hasDrivingIssue",
              label: "Est-ce que je rencontre des difficult\xE9s particuli\xE8res en conduisant ( accrochage ou accident au cours des cinq derni\xE8res ann\xE9es, probl\xE8me pour lire les panneaux, difficult\xE9 d\u2019appr\xE9cier les vitesses ou les distances, malaise au volant, me trompe souvent de route, suis g\xEAn\xE9(e) dans l\u2019ex\xE9cution de certaines man\u0153uvres...)",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                optionType: "button",
                buttonStyle: "solid",
                options: [{
                  label: 'Oui',
                  value: 1
                }, {
                  label: 'Non',
                  value: 0
                }]
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "doWearGlasses",
              label: "Est-ce que je porte des lunettes ou des lentilles de contact ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                optionType: "button",
                buttonStyle: "solid",
                options: [{
                  label: 'Oui',
                  value: 1
                }, {
                  label: 'Non',
                  value: 0
                }]
              })
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "alcoholFrequency",
                  label: "A quelle fr\xE9quence vous arrive t-il de consommer des boissons qui contiennent de l'alcool (vin ou bi\xE8re ou cidre ou ap\xE9ritif ou liqueur) ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Jamais',
                      value: 'Jamais'
                    }, {
                      label: 'Tous les jours',
                      value: 'Tous les jours'
                    }, {
                      label: "Moins d'une fois par semaine",
                      value: "Moins d'une fois par semaine"
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "alcoholQuantityPerDay",
                  label: "Combien de verres buvez-vous au cours d'une journ\xE9e ordinaire ou vous consommer de l'alcool ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(InputNumber, {})
                })]
              }), /*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "doDrugs",
                  label: "Est-ce que je consomme, m\xEAme occasionnellement des drogues illicites (cannabis, ecstasy, h\xE9ro\xEFne ou autres)",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "doneAddictionTreatment",
                  label: "Ai-je d\xE9j\xE0 \xE9t\xE9 suivie pour des probl\xE8mes de consommation d'alcool ou autres drogues ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasHeartProblem",
                  label: "Ai-je d\xE9j\xE0 eu des probl\xE8mes cardiaques, art\xE9riel, ou de tension ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasPacemaker",
                  label: "Ai-je un pacemaker, un d\xE9fibrillateur implant\xE9, des stents ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "hasViewProblem",
              label: "Ai-je des probl\xE8mes de vue suivis de mani\xE8re r\xE9guli\xE8re (glaucome, cataracte, DMLA, autres) ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                optionType: "button",
                buttonStyle: "solid",
                options: [{
                  label: 'Oui',
                  value: 1
                }, {
                  label: 'Non',
                  value: 0
                }]
              })
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasDizziness",
                  label: "Ai-je parfois des vertiges ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasMemoryProblem",
                  label: "Ai-je des trous de m\xE9moires, oublis fr\xE9quents, difficult\xE9s \xE0 me concentrer ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasSleepTrouble",
                  label: "Ai-je des difficult\xE9s de sommeil (probl\xE8mes d'endormissement, r\xE9veil fr\xE9quents, sommeil agit\xE9) ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "didSuddenlySleep",
                  label: "M'est-il d\xE9j\xE0 arriv\xE9 de m'endormir (m\xEAme tr\xE8s peu de temps) \xE0 table, au cours d'une r\xE9union, au cin\xE9ma, ou au volant, ou dans d'autres circonstances non appropri\xE9es ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "hasRespiratoryAssist",
              label: "Ai-je d\xE9j\xE0 eu des appareillages respiratoires (oxyg\xE8ne, masque pour la nuit, autres) ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                optionType: "button",
                buttonStyle: "solid",
                options: [{
                  label: 'Oui',
                  value: 1
                }, {
                  label: 'Non',
                  value: 0
                }]
              })
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasLostConsciousness",
                  label: "Ai-je d\xE9j\xE0 eu des pertes de connaissances, syncope ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "hasAvc",
                  label: "Ai-je d\xE9j\xE0 \xE9t\xE9 victime d'un accident vasculaire c\xE9r\xE9bral ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasAvcConsequences",
                  label: "Si oui y-a-t-il des cons\xE9quences aujourd'hui (maux de t\xEAtes, vertiges, paralysies, troubles de m\xE9moires ou autres) ?",
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })]
              })]
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "hasTrauma",
              label: "Ai-je d\xE9j\xE0 \xE9t\xE9 victime d'un traumatisme cr\xE2nien ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                optionType: "button",
                buttonStyle: "solid",
                options: [{
                  label: 'Oui',
                  value: 1
                }, {
                  label: 'Non',
                  value: 0
                }]
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "hasTraumaConsequences",
              label: "si oui, y'a-t-il des cons\xE9quences aujourd'hui (maux de t\xEAtes, vertiges, paralysie, troubles de m\xE9moire ou autres) ?",
              children: /*#__PURE__*/_jsx(Radio.Group, {
                optionType: "button",
                buttonStyle: "solid",
                options: [{
                  label: 'Oui',
                  value: 1
                }, {
                  label: 'Non',
                  value: 0
                }]
              })
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasDepression",
                  label: "Ai-je d\xE9j\xE0 pris des traitements pour le moral, d'angoisses, une d\xE9pression, les nerfs ou le sommeil ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "hasEpilepsy",
                  label: "Ai-je d\xE9j\xE0 fait une crise d'\xE9pilepsie ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "epilepsyDate",
                  label: "Si oui, date de la derni\xE8re crise",
                  children: /*#__PURE__*/_jsx(DatePicker, {})
                })]
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "doDiabete",
                  label: "Est-ce que je suis soign\xE9(e)pour du diab\xE8te ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasLackOfSugarIssues",
                  label: "Est-ce que j'ai d\xE9j\xE0 fait des malaises par manque de sucre (hypoglyc\xE9mies) ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "hasOtherProblem",
                  label: "Autres probl\xE8mes m\xE9dicaux ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'Oui',
                      value: 1
                    }, {
                      label: 'Non',
                      value: 0
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "otherProblemList",
                  label: "Si oui, merci de preciser",
                  children: /*#__PURE__*/_jsx(Input, {})
                })]
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                type: "primary",
                htmlType: "submit",
                children: "Sauvegarder"
              })
            })]
          })]
        })
      })
    })
  });
};
export default MedForm;